import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: "Cyrus' Story",
    href: '#story'
  }, {
    name: 'Goals',
    href: '#goals'
  }, {
    name: 'Support Cyrus',
    href: '#donate'
  }, {
    name: 'Highlights',
    href: '#highlights'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${isScrolled ? 'bg-usa-navy shadow-lg' : 'bg-usa-navy/95'}`} data-id="element-96">
      {/* Announcement Strip */}
      <div className="bg-usa-red text-white text-center text-xs sm:text-sm font-medium tracking-wide py-2 px-4" data-id="element-97">
        <span className="block sm:inline" data-id="element-98">Taekwondo Athlete Cyrus Barbour</span>
        <span className="hidden sm:inline mx-2 text-white/60" data-id="element-99">|</span>
        <span className="block sm:inline" data-id="element-100">
          Support His Journey Toward Team USA and the Olympic Dream
        </span>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-101">
        <div className="flex justify-between items-center h-20" data-id="element-102">
          {/* Logo */}
          <a href="#home" className="flex items-center gap-2 group" data-id="element-103">
            <span className="font-display text-2xl font-bold text-white tracking-wider" data-id="element-104">
              TKD FUTURE
            </span>
            <div className="w-2 h-2 bg-usa-red rounded-full group-hover:bg-usa-gold transition-colors" data-id="element-105" />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-106">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-gray-300 hover:text-white transition-colors uppercase tracking-wide" data-id="element-107">
                {link.name}
              </a>)}
            <a href="#donate" className="bg-usa-red hover:bg-red-700 text-white px-6 py-2.5 font-display text-lg tracking-wide transition-colors" data-id="element-108">
              Donate
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-white p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-109">
            {mobileMenuOpen ? <X size={28} data-id="element-110" /> : <Menu size={28} data-id="element-111" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-112">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-usa-navy border-t border-gray-800 overflow-hidden" data-id="element-113">
            <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-114">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="block px-3 py-3 text-base font-medium text-gray-300 hover:text-white hover:bg-gray-800 transition-colors uppercase tracking-wide" data-id="element-115">
                  {link.name}
                </a>)}
              <a href="#donate" onClick={() => setMobileMenuOpen(false)} className="block w-full text-center mt-4 bg-usa-red hover:bg-red-700 text-white px-6 py-3 font-display text-xl tracking-wide transition-colors" data-id="element-116">
                Donate Now
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}